import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-023bc7be"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "aigame-introduce-title" }, "评委介绍", -1))
const _hoisted_2 = { class: "aigame-introduce-list" }
const _hoisted_3 = { class: "swiper-container" }
const _hoisted_4 = { class: "swiper-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "aigame-introduce-item__btm" }
const _hoisted_7 = { class: "aigame-introduce-item__title" }
const _hoisted_8 = { class: "aigame-introduce-item__subtitle" }
const _hoisted_9 = { class: "aigame-introduce-item__mask" }
const _hoisted_10 = { class: "aigame-introduce-item__mask--bd" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-prev" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-button-next" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.juryItem, (arr, ind) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "swiper-slide",
              key: ind
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arr, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "aigame-introduce-item",
                  key: index
                }, [
                  _createElementVNode("img", {
                    src: item.src,
                    alt: "",
                    class: "aigame-introduce-item__img"
                  }, null, 8, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(item.subTitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(item.mask), 1)
                  ])
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ])
    ])
  ]))
}